import { useMemo } from 'react';
import { useClients } from '~/hooks/reactQuery/queries/useClients';
import { getAssociableClients } from '../AddToAnotherClientModal.utils';
export const useAssociableClients = (param)=>{
    let { contact, contacts } = param;
    const { clients, isLoading, error } = useClients({
        refreshOnHookMount: true
    });
    const associableClients = useMemo(()=>getAssociableClients({
            clients,
            contacts,
            contact
        }), [
        clients,
        contacts,
        contact
    ]);
    return {
        clients: associableClients,
        isLoading,
        isError: error != null
    };
};
